import { autoChooseClassnames, getId } from '@common/utils/brandDiffsUtils';
import { AccordionStepsActionTypes } from '@state/features/common.types';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
const AccordionStep = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const el = useRef();
    const open = () => {
        console.warn('AccordionStep navigate ' + props.id);
        let navigate = true;
        if (props.callback) {
            navigate = props.callback();
        }
        if (navigate) {
            dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: props.id });
        }
    };
    useEffect(() => {
        var _a;
        if (props.openstep === props.id) {
            (_a = el === null || el === void 0 ? void 0 : el.current) === null || _a === void 0 ? void 0 : _a.focus();
            if (!props.disablescroll) {
                return;
            }
            if (props.id != 'packaging') {
                setTimeout(() => {
                    var _a, _b;
                    console.info('scrollIntoView ', props.id);
                    // el?.current?.scrollIntoView();
                    window.scroll({
                        top: window.pageYOffset + ((_a = el === null || el === void 0 ? void 0 : el.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) - (((_b = el.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top) < 0 ? 48 : 0),
                        behavior: 'smooth',
                    });
                }, 1000);
            }
        }
    }, [props.openstep]);
    return (React.createElement("div", { className: "accordion-step", tabIndex: -1, id: `${props.id}Step`, ref: el },
        React.createElement("div", { className: classNames(`step__header`, { 'is-active': props.openstep === props.id }, { 'is-done': props.isDone }) },
            (props.editable && (React.createElement("div", { className: "step__header__content" },
                React.createElement("h2", { className: "step__header__title", id: `${props.id}Title` }, props.title),
                React.createElement("button", { type: "button", className: autoChooseClassnames({
                        MO: 'step__header__edit',
                        ST: 'step__header__edit button button--tertiary',
                    }), onClick: () => {
                        open();
                        if (!!props.pushAnalytics) {
                            props.pushAnalytics();
                        }
                    }, "aria-expanded": props.openstep === props.id, "aria-label": t('button.edit' + props.id) }, getId() === 'MO' ? React.createElement(React.Fragment, null, t('button.edit')) : React.createElement("span", null, t('button.edit')))))) || (React.createElement("div", { className: "step__header__content" },
                React.createElement("h2", { className: "step__header__title", id: `${props.id}Title` }, props.title))),
            props.description && React.createElement("div", { className: "step__header__description" }, props.description)),
        props.openstep === props.id && (React.createElement("div", { className: "step__panel", id: `${props.id}Panel`, role: "region", "aria-labelledby": `${props.id}Title` }, props.children)),
        props.openstep !== props.id && props.id !== 'customer' && !props.editable && !props.isDone && React.createElement("p", { className: "visually-hidden" }, t('checkout.step.notavailable'))));
};
export default AccordionStep;
